import { Reveal } from "@/components/site/Motion";
import { Portrait } from "@/components/site/Portrait";
import { LinkButton } from "@/components/site/LinkButton";

export const GuidePreview = () => (
  <section className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-24 sm:px-8 md:grid-cols-[0.8fr_1.2fr] md:gap-20 md:py-32 lg:px-12" data-testid="guide-preview">
    <Reveal className="mx-auto w-full max-w-sm md:max-w-none">
      <Portrait testId="guide-preview-portrait" />
    </Reveal>
    <Reveal delay={0.15}>
      <p className="eyebrow text-center sm:text-left">Meet your coach</p>
      <h2 className="font-display mt-4 text-center text-4xl leading-tight text-[#221e1b] sm:text-left sm:text-5xl" data-testid="guide-preview-name">
        Sheetal Garg
      </h2>
      <p className="mt-2 text-center text-sm font-semibold uppercase tracking-[0.2em] text-[#5d544c] sm:text-left">Founder and Lifestyle Coach, Panchmaya</p>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-[#5d544c] md:text-lg" data-testid="guide-preview-intro">
        Sheetal is the founder of Panchmaya. She draws on her background in mindful living, guided
        visualization and embodiment practices to bring a gentle, reflective approach to private
        1:1 lifestyle coaching. Her work invites clients to explore everyday patterns, reconnect
        with what matters to them and make intentional changes in daily life.
      </p>
      <div className="mt-10 flex justify-center sm:justify-start">
        <LinkButton to="/about" variant="text" testId="guide-read-story-link">Read their story</LinkButton>
      </div>
    </Reveal>
  </section>
);
